import { WatchLaterList } from '../features/watchLater/components/WatchLaterList';
import { jsx as _jsx } from "react/jsx-runtime";
export const WatchLater = () => {
  return /*#__PURE__*/_jsx(WatchLaterList, {});
};
export default WatchLater;